import React from 'react'

export default ({ width = 100, height = 100, fill = '#dfedeb' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 100 100">
      <g id="CO2_icon" transform="translate(-349 -387)">
        <g id="noun_co2_3571122" transform="translate(362 387)">
          <g id="Group_1091" data-name="Group 1091" transform="translate(0 29.763)">
            <path id="Path_3230" data-name="Path 3230" d="M283.254,513.98a20.85,20.85,0,0,1,40.014,0,17.334,17.334,0,0,1,10.092,5.25,19.008,19.008,0,0,1,5.162,13.092,10.851,10.851,0,0,1-10.578,11.107H278.578A10.851,10.851,0,0,1,268,532.321a19.008,19.008,0,0,1,5.162-13.092A17.334,17.334,0,0,1,283.254,513.98Z" transform="translate(-268 -499)" fill={fill} fillRule="evenodd"/>
          </g>
          <g id="Group_1093" data-name="Group 1093" transform="translate(11.107 0)">
            <ellipse id="Ellipse_735" data-name="Ellipse 735" cx="9.011" cy="9.011" rx="9.011" ry="9.011" fill={fill}/>
          </g>
          <g id="Group_1094" data-name="Group 1094" transform="translate(3.505 85.465)">
            <ellipse id="Ellipse_736" data-name="Ellipse 736" cx="7.268" cy="7.268" rx="7.268" ry="7.268" fill={fill}/>
          </g>
          <g id="Group_1095" data-name="Group 1095" transform="translate(48.228 9.244)">
            <ellipse id="Ellipse_737" data-name="Ellipse 737" cx="12.958" cy="12.958" rx="12.958" ry="12.958" fill={fill}/>
          </g>
        </g>
        <g id="Rectangle_1829" data-name="Rectangle 1829" transform="translate(349 387)" fill="none" stroke="#707070" strokeWidth="1" opacity="0">
          <rect width="100" height="100" stroke="none"/>
          <rect x="0.5" y="0.5" width="99" height="99" fill="none"/>
        </g>
      </g>
    </svg>
  )
}
